import React from "react";

import "./Dashboard.scss";

export const Dashboard = () => {
  return <div className="Dashboard">Dashboard</div>;
};
